<script lang="ts">
  import { EventTracking } from "@shared/services/event_tracking/events";
  import { CartOrderGroupEntity } from "@shared/services/event_tracking/entities";
  import type { OrderGroup } from "@shared/types/OrderGroup";
  import BannerBase from "@retailer/svelte/Payments/Banners/Base.svelte";
  import UIRouterLink from "@shared/svelte/Components/UIRouterLink.svelte";

  export let orderGroup: OrderGroup;

  let orderGroupEvent = new CartOrderGroupEntity({
    orderGroupId: orderGroup.id,
    type: "provi_pay_banner",
  });

  const { trackMrcEvents } = EventTracking;
</script>

<div
  class="fizz-stack-48"
  data-testid="order_sucess_pay_banner"
  use:trackMrcEvents={[[orderGroupEvent]]}
>
  <BannerBase
    onCloseEnabled={false}
    iconType={"Statement"}
    heading="Make invoice payments a breeze with ProviPay"
  >
    <p class="fizz-text-medium">
      ProviPay makes managing and paying your distributor invoices simpler than ever with convenient
      features like selecting your own payment dates, auto pay, and applying credits.
      <UIRouterLink
        stateName="layout.invoices"
        useTrackClick={true}
        targetObjectType="order_submission_success_provi_pay_link"
        trackingParams={[orderGroupEvent]}
      >
        <span class="fizz-text-strong">Check out ProviPay</span>
      </UIRouterLink>
    </p>
  </BannerBase>
</div>
